import { Box } from "../Box";
import { DateRangePicker } from "../DateRangePicker/index";
import { Paragraph } from "../Paragraph";
import { Slider } from "../Slider";
import { Form, Formik } from "formik";
import Select from "../Select";
import { Button } from "../Button";
import { useMandateCheckList } from "../../data/useMandateCheckList";
import { capitalise } from "../../utils/string";
import { screeningView } from "../../hooks/dashboardViews/screening";

type FiltersProps = {
  isOpen?: boolean;
  onRequestClose: () => void;
  filters: any;
  onSubmit: (values: any) => void;
  type?: "individual" | "entity" | "";
};

// Derived from the view schema's own defaults so the panel's "Clear All"
// and the chip bar's "Clear all" can never disagree (tech spec 7.1).
const { fields } = screeningView;
const initialState = {
  dateStarted: [fields.dateStartedFrom.default, fields.dateStartedTo.default],
  checkType: fields.checkType.default,
};

export const ChecksFilters = (props: FiltersProps) => {
  const { isOpen, onRequestClose, onSubmit, filters, type = "" } = props;
  const adverseMediaCheckName =
    type === "entity" ? "entity_adverse_media_check" : "adverse_media_check";
  // The mandate_check endpoint filters this catalogue by the tenant's own
  // screening provider, so asking for both generations returns only the checks
  // that tenant can actually hold records against.
  const checkNames =
    type === ""
      ? [
          "address_verification_check",
          "pep_%26_sanctions_check",
          "adverse_media_check",
          "entity_adverse_media_check",
          "sanctions_check",
          "ln_screening_check",
          "ln_screening_check_entity",
        ]
      : [
          "address_verification_check",
          "pep_%26_sanctions_check",
          adverseMediaCheckName,
          "sanctions_check",
          type === "entity" ? "ln_screening_check_entity" : "ln_screening_check",
        ];

  const { data: mandateCheckList } = useMandateCheckList(false, checkNames);

  const options = mandateCheckList?.data?.map(({ id, name }) => ({
    label: capitalise(name.replace(/_/g, " ")),
    value: name,
  }));

  return (
    <Slider isOpen={isOpen} onRequestClose={onRequestClose}>
      <Box p={3} overflowY="auto" height={"calc(100vh - 211px)"}>
        <Formik
          initialValues={filters}
          onSubmit={(values, helpers) => {
            onSubmit(values);
            helpers.resetForm({ values });
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Paragraph as="h2" fontSize={3} mt="0px" display="flex">
                Filters
                <Button
                  type="reset"
                  px={2}
                  variant="text"
                  size="small"
                  position="absolute"
                  top="26px"
                  right="75px"
                  onClick={() => {
                    props.resetForm({ values: initialState });
                    props.submitForm();
                  }}
                >
                  Clear All
                </Button>
              </Paragraph>

              <DateRangePicker
                value={props.values.dateStarted}
                onChange={(option: any) =>
                  props.setFieldValue("dateStarted", option)
                }
                mt={3}
                label="Date Started"
                name="dateStarted"
              />

              <Select
                onChange={(option: any) =>
                  props.setFieldValue("checkType", option.value)
                }
                value={
                  options.find(
                    ({ value }) => value === props.values.checkType
                  ) || ""
                }
                options={options}
                mt={3}
                label="Check Type"
                name="checkType"
              />

              {props.dirty && (
                <Button type="submit" mt="2" size="large" width="100%">
                  Apply
                </Button>
              )}
            </Form>
          )}
        </Formik>
      </Box>
    </Slider>
  );
};
